import React from 'react'
import { ClipLoader } from 'react-spinners'
import { Box } from '@mui/material'
import CenteredBox from '../centeredBox/centeredBox'

function Loading() {
    return (
        <Box sx={{ minHeight: 'calc(100vh - 64px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CenteredBox>
                <ClipLoader
                    color={'primary'}
                    loading={true}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </CenteredBox >
        </Box>
    )
}

export default Loading